module.exports = "<p>\n  payment works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/payment/payment.component.html
// module id = ../../../../../src/app/home/payment/payment.component.html
// module chunks = common